import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {gsap} from "gsap";
import {Game} from "../Game";
import {IFeatureData} from "../server/IData";
import {Symbol, XSplitStates} from "../reels/Symbol";
import {Sound} from "../sound/Sound";

export class XSplitRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.model.xSplitData.length > 0 && !Game.model.gameData.suspendedAction;
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const featureTl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            xSplits: IFeatureData[] = Game.model.xSplitData,
            verticalXSplit: boolean = Game.model.gameData.verticalXSplit;

        featureTl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(featureTl);
            });
        });

        xSplits.forEach((xSplit: IFeatureData, idx: number) => {
            const tl: gsap.core.Timeline = gsap.timeline(),
                xSplitSymbol: Symbol = Game.reelsView.reelModels[xSplit.reelId].getSymbolAt(xSplit.rowId, "XS");

            tl.add(xSplitSymbol.getStateAnimation(XSplitStates.TRIGGER));

            tl.addLabel("splitPaySymbols", (12 / 30));

            // row id is same as xSplit origin rowId
            if (verticalXSplit) {
                for (let rowId: number = 0; rowId < Game.ACTIVE_ROWS_NUM; rowId++) {
                    // don't split xSplit symbol itself
                    if (xSplit.rowId !== rowId) {
                        const reelsSymName: string = Game.model.gameData.reels[xSplit.reelId][rowId];
                        if (reelsSymName !== "MX") {
                            tl.add(Game.reelsView.reelModels[xSplit.reelId].getSymbolAt(rowId, reelsSymName).splitSymbol(), "splitPaySymbols");
                        }
                        if (!reelsSymName.includes("MX") && reelsSymName.includes("M")){
                            tl.add(()=>{
                                Game.soundPlayer.playSound(Sound.CRATE_PICK_M10_M50, 1);
                            });
                        }
                    }
                }
            } else {
                for (let reelId: number = 0; reelId < Game.ACTIVE_REELS_NUM; reelId++) {
                    // don't split xSplit symbol itself
                    if (xSplit.reelId !== reelId) {
                        const reelsSymName: string = Game.model.gameData.reels[reelId][xSplit.rowId];
                        if (reelsSymName !== "MX") {
                            tl.add(Game.reelsView.reelModels[reelId].getSymbolAt(xSplit.rowId, reelsSymName).splitSymbol(), "splitPaySymbols");
                        }
                        if (!reelsSymName.includes("MX") && reelsSymName.includes("M")){
                            tl.add(()=>{
                                Game.soundPlayer.playSound(Sound.CRATE_PICK_M10_M50, 1);
                            });
                        }
                    }
                }
            }

            tl.add(() => {
                Game.soundPlayer.playSound(Sound.XS_ACTIVATE, 1);
            }, "splitPaySymbols");
            tl.add(xSplitSymbol.getStateAnimation(XSplitStates.DISAPPEAR));
            tl.add(() => {
                xSplitSymbol.updateTexture("W");
            });

            featureTl.add(tl, (0.3 * idx));
        });

        featureTl.to(this, {
            duration: 0.1
        });
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }
}